import { DEFAULT_HITS_VIEW } from 'constants/defaults'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import CampaignDetailsHeader from './components/CampaignDetailsHeader'
import { LayoutView } from './components/CampaignLayoutToggler'
import HitsView from './components/HitsView'

const platformOptions = ['Instagram', 'Facebook', 'TikTok', 'YouTube', 'Reddit']

export default function CampaignDetail(): JSX.Element {
  const params = useParams()
  const [layout, setLayout] = useState<LayoutView>(DEFAULT_HITS_VIEW)
  const [isHideContent, setIsHideContent] = useState<boolean>(false)
  const [likes, setLikes] = useState<string[]>([])
  const [profileFollowers, setProfileFollowers] = useState<string[]>([])
  const [filterPlatforms, setFilterPlatforms] = useState<
    typeof platformOptions
  >([])
  const [categories, setCategories] = useState<string[]>([])
  const [volumes, setVolumes] = useState<string[]>([])

  return (
    <div>
      {/* <CampaignDetailsHeader
        layout={layout}
        setLayout={setLayout}
        campaignId={Number(params.campaignId)}
        setIsHideContent={setIsHideContent}
        isHideContent={isHideContent}
        setLikes={setLikes}
        setProfileFollowers={setProfileFollowers}
        setFilterPlatforms={setFilterPlatforms}
        setCategories={setCategories}
        setVolumes={setVolumes}
        likes={likes}
        profileFollowers={profileFollowers}
        filterPlatforms={filterPlatforms}
        categories={categories}
        volumes={volumes}
      /> */}
      <HitsView
        layout={layout}
        campaignId={Number(params.campaignId)}
        isHideContent={isHideContent}
        likes={likes}
        profileFollowers={profileFollowers}
        filterPlatforms={filterPlatforms}
        categories={categories}
        volumes={volumes}
        setFilterPlatforms={setFilterPlatforms}
        setCategories={setCategories}
        setLikes={setLikes}
        setIsHideContent={setIsHideContent}
      />
    </div>
  )
}
